module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/snowflake-bed7105cef7f982bdb73abf932fdb2c7.svg";